export default __webpack_public_path__ + "media/images/icons/icon_email-185c94df8b200b5513adfd2cb2c90cf2.svg";